import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { LoaderService } from '../services/shared/loader.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    
    private requests: HttpRequest<any>[] = [];
    
    constructor(
        private router: Router,
        private loaderService: LoaderService,
      ) { }
    
    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        this.requests.splice(i, 1);
        this.loaderService.isPageLoading.next(this.requests.length > 0);
        //console.log(this.loaderService.isPageLoading.value);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        this.loaderService.isPageLoading.next(true);
        //console.log(this.loaderService.isPageLoading.value);

        //sessionStorage.removeItem('XauthToken');
        const token: string = sessionStorage.getItem('XauthToken');
        const requestURL: string = request.url;

        //console.log(requestURL);

        if (token) {
            request = request.clone({ headers: request.headers.set('x-access-token', token) });
            //console.log("Token: " + token);
        }
        else{
            if(!requestURL.includes('Signin', 0) && !requestURL.includes('GetSharedUserNews', 0) && !requestURL.includes('GetSharedUserRepository', 0)){
                this.router.navigate(['./?c=' + sessionStorage.getItem('CompanyId')]); 
                //console.log("Timeout");
            }
        }

        if (!request.headers.has('Content-Type') && !request.headers.has('isUpload')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        //request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log('event--->>>', event);
                    // console.log('status--->>>', event.status);
                    if(event.status === 401){
                        console.log("Timeout");
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                let data = {};
                data = {
                    reason: error.error && error.error.message ? error.error.message : '',
                    status: error.status
                };
                if(error.status == 401){
                    this.router.navigate(['./?c=' + sessionStorage.getItem('CompanyId')]); 
                }
                //console.log(error);
                
                return throwError(data);
            }),
            ).finally(() => {
                this.removeRequest(request);
            });
    }
}